import { render } from "./TeamReservation.vue?vue&type=template&id=58f01240&scoped=true"
import script from "./TeamReservation.vue?vue&type=script&lang=js"
export * from "./TeamReservation.vue?vue&type=script&lang=js"

import "./TeamReservation.vue?vue&type=style&index=0&id=58f01240&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f01240"]])

export default __exports__